import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle("no-scroll", !isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove("no-scroll");
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img src="/images/RixxyMCLogo.png" alt="RixxyMC Logo" className="logo-img" />
        </Link>
      </div>
      {/* Improved Hamburger Icon */}
      <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
      {/* Menu Items */}
      <div className={`menu ${isMenuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>About</Link>
          </li>
          <li>
            <Link to="/forms" onClick={closeMenu}>Forms</Link>
          </li>
          <li>
            <Link to="/stats" onClick={closeMenu}>Stats</Link>
          </li>
          <li>
            <Link to="/vote" onClick={closeMenu}>Vote</Link>
          </li>
          <li>
            <Link to="/gallery" onClick={closeMenu}>Gallery</Link>
          </li>
          <li>
            <Link to="/updates" onClick={closeMenu}>Updates</Link>
          </li>
          <li>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
